import { render, staticRenderFns } from "./KeywordDetailModal.vue?vue&type=template&id=52db2426&scoped=true&"
import script from "./KeywordDetailModal.vue?vue&type=script&lang=js&"
export * from "./KeywordDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./KeywordDetailModal.vue?vue&type=style&index=0&id=52db2426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db2426",
  null
  
)

export default component.exports